import { render, staticRenderFns } from "./widgetIndex.vue?vue&type=template&id=7dfaf558&scoped=true"
import script from "./widgetIndex.vue?vue&type=script&lang=js"
export * from "./widgetIndex.vue?vue&type=script&lang=js"
import style0 from "./widgetIndex.vue?vue&type=style&index=0&id=7dfaf558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfaf558",
  null
  
)

export default component.exports